var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValence1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5c37.8,0,68.5,30.7,68.5,68.5 C146.5,115.8,115.8,146.5,78,146.5z M78,14.3c-35.1,0-63.7,28.6-63.7,63.7s28.6,63.7,63.7,63.7s63.7-28.6,63.7-63.7 S113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,108.9c-1.2,0-2.1,0.1-3.1,0.4l-1.1,0.3l-2,0.7l-1.7,0.6c-3.5,1.1-7.2,1.6-12.7,1.6c-5.8,0-9.6-0.5-13.1-1.6 l-1.1-0.4l-2.3-0.9c-1.4-0.5-2.4-0.7-4-0.7c-3,0-6.3,2.9-7.7,6.7c-1.2,3-0.7,4.1,0.9,4.1c4.7,0,7.9-0.4,12-1.2l6.4-1.4 c3.2-0.6,5.7-0.9,9-0.9s5.8,0.3,9,0.9l2,0.4l4.4,1c4.1,0.9,7.3,1.2,12,1.2c1.6,0,2.1-1.1,0.9-4.1 C107.2,111.8,103.9,108.9,100.9,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,64.1c1.4-0.8,3.7-0.8,5.1,0c4.1,2.3,10.4,3.5,19.1,3.5c2,0,3.6,0.9,3.6,2.1s-1.6,2.1-3.6,2.1 c-10.5,0-18.6-1.5-24.2-4.7C88.7,66.2,88.7,64.9,90.1,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,64.1c1.4,0.8,1.4,2.1,0,2.9c-5.6,3.2-13.7,4.7-24.2,4.7c-2,0-3.6-0.9-3.6-2.1s1.6-2.1,3.6-2.1 c8.7,0,15-1.2,19.1-3.5C69.9,63.3,72.2,63.3,73.6,64.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValence1);
export default __webpack_public_path__ + "static/media/Valence1.623ba37518d2c69a258c88fb7619855f.svg";
export { ForwardRef as ReactComponent };